import { WarningAmber } from "@mui/icons-material"
import { Box, SxProps, Tooltip, Typography } from "@mui/material"
import { FC } from "react"

interface OrganizationLineProps {
  text: string | JSX.Element
  tooltip?: string | JSX.Element
  sx?: SxProps
  isSelected?: boolean
  id?: string
  onClick?: (id: string) => void
}

const OrganizationLine: FC<OrganizationLineProps> = ({ text, tooltip, sx, isSelected, onClick, id }) => {

  return (
    <Box 
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        border: isSelected ? '1px solid #17374F' : 
          tooltip ? '0.25px solid #00000033'
        : '0.25px solid #00000033',
        backgroundColor: tooltip ? '#EEEFE6': '#FFFFFF',
        px: '12px',
        py: '9px',
        cursor: !onClick ? 'default' : 'pointer',
        ...sx
      }}
      onClick={(id && onClick) ? () => onClick(id) : undefined}
    >
      <Typography 
        variant="body2" 
        sx={{ 
          fontSize: '14px', 
          lineHeight: '20px', 
          color: isSelected ? '#000000' : 
            tooltip ? '#707070' 
          : 'primary.main' 
        }}
      >
        {text}
      </Typography>
      {tooltip && (
        <Tooltip title={tooltip}>
          <WarningAmber sx={{ fontSize: '20px', color: '#F47B44' }} />
        </Tooltip>
      )}
    </Box>
  )
}

export default OrganizationLine